/**
 * @generated SignedSource<<15644dc2149acf97d282f5d95853aa2f>>
 * @relayHash 9177e699c384d354ea20ddb70e210b55
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9177e699c384d354ea20ddb70e210b55

import { ConcreteRequest } from 'relay-runtime';
export type ShiftInformation = "MEDICAL_SUPERVISOR" | "NON_OPERATIVE_SHIFT" | "OPERATIVE_SHIFT";
export type useShiftQuery$variables = Record<PropertyKey, never>;
export type useShiftQuery$data = {
  readonly todayShiftOverview: ReadonlyArray<{
    readonly shiftEnd: string;
    readonly shiftInformation: ShiftInformation;
    readonly shiftStart: string;
    readonly shiftType: string;
  }>;
};
export type useShiftQuery = {
  response: useShiftQuery$data;
  variables: useShiftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TodayShiftOverviewOutput",
    "kind": "LinkedField",
    "name": "todayShiftOverview",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shiftEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shiftStart",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shiftInformation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shiftType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useShiftQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useShiftQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "9177e699c384d354ea20ddb70e210b55",
    "metadata": {},
    "name": "useShiftQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ad099701c2480854129ace88d540a6cf";

export default node;
